import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ModalSize } from 'src/app/Enums/usersFilterEnums';
import { Material } from 'src/app/shared/classes/Material';
import { Outward } from 'src/app/shared/classes/Outward';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { OutwardService } from 'src/app/shared/services/outward.service';
import { OutwardMaterial } from '../../../shared/classes/Material';
import { ApproverCommentsComponent } from '../approver-comments/approver-comments.component';
import { Location } from '@angular/common';
import { AuditData } from 'src/app/shared/classes/AuditTrail';
import { OutwardStatus, OutwardStatusName } from 'src/app/Enums/outwardEnum';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';
import * as XLSX from 'xlsx';
import * as mammoth from 'mammoth';


@Component({
  selector: 'app-view-outward-approver',
  templateUrl: './view-outward-approver.component.html',
  styleUrls: ['./view-outward-approver.component.less']
})
export class ViewOutwardApproverComponent implements OnInit {
  dateInputData: any = {};
  requestId: number;
  requestName: string;
  requestTypeId: number;
  requestTypeName: string;
  requestDateTime:any;
  returnDateTime: any;
  revisedDateTime: any;
  remark: string;
  gatepassNumber: string;
  serialNumber: string;
  materialSentToVendorId: number;
  materialSentToVendorName: string;
  materialCarriedByVendorId: number;
  materialCarriedByVendorName: string;
  approverEmailL1: string;
  approverEmailL2: string;
  practiceId: number;
  practiceName: string;
  purpose: string;
  status: string;
  statusId: number;
  previousStatusId:number;
  isActive: boolean;
  cityId: number;
  cityName: string;
  officeId: number;
  officeName: string;
  authorizedBy:string;
  createdBy:string;
  declinedByNotes:string;
  cancelledByNotes:string;
  updatedBy:string;
 // materialList:Material[] = [];
 fTime: Date = new Date;
  dTime:Date=new Date;
  fromtimevalue: any;
  duetimevalue:any;
  rdTime:Date=new Date;
  revisedduetimevalue:any;
  public materialList:OutwardMaterial[] = [];
  OutwardDetails:Outward;
  id: any;
   service_URL: any;
  private unsubscribe$ =new Subject<void>();
  EditOutwardDetails:any;
  modalRef: BsModalRef;
  selectedRequest: any;
  searchText : string = "";
  showLoading: boolean = true;
  emailId: string ='';
  Appr1Data: any;
  Appr2Data: any;
  getAllUsers:any;
  Roles: any = [];
  
  attachedFiles: { name: string, type?: string, data?: string | ArrayBuffer, requestType?: string, fileId?: number }[] = [];
  isMobileView = false;
  private readonly mobileBreakpoint = 768;
  

  
  constructor(private location: Location,
    private route: ActivatedRoute,
    private outwardService: OutwardService,
    private _dataContextService: DataContextService,
    private modalService: BsModalService,
    private toast: ToastrService,
    private rounter:Router,
    private trackeromnitureservice:TrackerOmnitureService
    ) {
    this.service_URL = ConstantsService;
  }
  
  ngOnInit(): void {
    this.syncViewportState();
    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('view-outward-approver',username);
    this.trackeromnitureservice.trackPage("pageView");

    //this.dateInputData.EndDate = new Date();
    this.id = this.route.snapshot.params['id'];
    // console.log(this.id);
    this.emailId=localStorage.getItem('email');

    this.dateInputData.StartDate = new Date();
    //this.dateInputData.StartDate.setDate(this.dateInputData.StartDate.getDate() - 7);
    this.dateInputData.maxDate = new Date();
    this.dateInputData.FromMinDate = new Date();
    this.dateInputData.FromMinDate.setDate(this.dateInputData.StartDate.getDate() - 1095);
    // Set Roles array with appropriate roles
    this.Roles = ['L1Approver'];

    // First load outward details, then fetch approver details by email
    this.fillOutwardData(this.id);
 }

 getAppr1Data()
  {
    const approverEmailL1 = this.OutwardDetails && this.OutwardDetails.approverEmailL1;
    const approverEmailL2 = this.OutwardDetails && this.OutwardDetails.approverEmailL2;

    if (approverEmailL1) {
      const urlL1 = this.service_URL.Users.getuserbyemail + approverEmailL1;
      this._dataContextService.get<any>(urlL1)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(res => {
          const raw = Array.isArray(res) ? res[0] : res;
          const user = raw && raw.userData ? raw.userData : raw;

          if (user) {
            // Prefer backend-provided firstLastName; otherwise build "FirstName,LastName"
            if (user.firstLastName) {
              this.approverEmailL1 = user.firstLastName;
            } else if (user.firstName || user.lastName) {
              const first = user.firstName ? user.firstName : '';
              const last = user.lastName ? user.lastName : '';
              this.approverEmailL1 = `${first}${first || last ? ',' : ''}${last}`;
            } else {
              // Fallback to email if no name info
              this.approverEmailL1 = approverEmailL1;
            }
          } else {
            this.approverEmailL1 = approverEmailL1;
          }
        });
    }

    if (approverEmailL2) {
      const urlL2 = this.service_URL.Users.getuserbyemail + approverEmailL2;
      this._dataContextService.get<any>(urlL2)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(res => {
          const raw = Array.isArray(res) ? res[0] : res;
          const user = raw && raw.userData ? raw.userData : raw;

          if (user) {
            if (user.firstLastName) {
              this.approverEmailL2 = user.firstLastName;
            } else if (user.firstName || user.lastName) {
              const first = user.firstName ? user.firstName : '';
              const last = user.lastName ? user.lastName : '';
              this.approverEmailL2 = `${first}${first || last ? ',' : ''}${last}`;
            } else {
              this.approverEmailL2 = approverEmailL2;
            }
          } else {
            this.approverEmailL2 = approverEmailL2;
          }
        });
    }
  }
  //  addMaterial(){
  //    this.materialList.push(new Material())
  //    console.log(this.materialList)
  //  }
 
  //  removeMaterial(index:number){
  //    if(index > -1){
  //     this.materialList.splice(index,1);
  //    }
  //  }
  //  goBack() : void{
  //    this.location.back();
  //  }
 


fillOutwardData(id: any) {
 let url =this.service_URL.OutwardDetails.GetDataById+'/'+id;
      
 this._dataContextService.get(url)
 .pipe(takeUntil(this.unsubscribe$))
 .subscribe(res=>{
  //  console.log(res);
   this.EditOutwardDetails=res;
   this.OutwardDetails=this.EditOutwardDetails;
   this.requestId=this.OutwardDetails.requestId;
   this.serialNumber=this.OutwardDetails.serialNumber;
   this.requestName=this.OutwardDetails.requestName;
   this.requestTypeName=this.OutwardDetails.requestTypeName;
   this.requestDateTime= moment(this.OutwardDetails.requestDateTime).format("MMM/DD/yy");
   this.returnDateTime=moment(this.OutwardDetails.returnDateTime).format("MMM/DD/Y");
   this.revisedDateTime=moment(this.OutwardDetails.revisedDate).format("MMM/DD/Y");
   this.fTime =new Date(this.OutwardDetails.requestDateTime);
   this.fromtimevalue = this.GetTimeForDates(this.fTime);
   this.dTime=new Date(this.OutwardDetails.returnDateTime);
   this.duetimevalue=this.GetTimeForDates(this.dTime);
   this.rdTime=new Date(this.OutwardDetails.revisedDate);
   this.revisedduetimevalue=this.GetTimeForDates(this.rdTime);
   this.materialSentToVendorName=this.OutwardDetails.materialSentToVendorName;
   this.materialCarriedByVendorName=this.OutwardDetails.materialCarriedByVendorName;
   
   // After outward details are loaded, fetch approver details by email
   this.getAppr1Data();
    
    if (this.OutwardDetails.attachedFiles && this.OutwardDetails.attachedFiles.length > 0) {
      this.attachedFiles = this.OutwardDetails.attachedFiles;
    } else {
      this.attachedFiles = [];
    }
   this.authorizedBy=this.OutwardDetails.authorizedBy;
   this.practiceName=this.OutwardDetails.practiceName;
   this.purpose=this.OutwardDetails.purpose;
   this.gatepassNumber=this.OutwardDetails.gatepassNo;
   this.cityName=this.OutwardDetails.cityName;
   this.officeName=this.OutwardDetails.officeName;
   this.remark=this.OutwardDetails.remark;
   this.materialList=this.OutwardDetails.materialList;
   this.declinedByNotes=this.OutwardDetails.declinedByNotes;
   this.cancelledByNotes=this.OutwardDetails.cancelledByNotes;
   this.status=this.OutwardDetails.status;
   this.showLoading = false;

 })

       // this._dataContextService.get<any>(url)
       // .pipe(takeUntil(this.unsubscribe$))
       // .subscribe(res => {
       // })
       
}
GetTimeForDates(date: Date): string {
 let time = moment(date).format("hh:mm A");
 return time;
}

@HostListener('window:resize')
onWindowResize(): void {
  this.syncViewportState();
}
onReject(selectedRequest : any){
  console.log('OnReject selectedRequest:',selectedRequest); 
  this.modalRef = this.modalService.show(ApproverCommentsComponent,{
    initialState : {
      selectedRequest : selectedRequest
    }
  })
  this.modalRef.setClass(ModalSize.Large);
}

onAccept(selectedRequest: any) {
  let newstatus = 0;
  if (selectedRequest.status == "Created") {
    newstatus = 5;
  }
  let params = {
    statusId: newstatus,
    previousStatusId: OutwardStatus.Created,
    requestId: this.requestId,
    Updatedby: this.emailId,
    L1ApprovedDateTime:new Date().toISOString()
  };

  let auditData = [];

  let statusChangeAudit: AuditData = new AuditData();
  statusChangeAudit.changedAttribute = "Status";
  statusChangeAudit.oldValue = "Created";
  statusChangeAudit.newValue = "L1 Approved";

  auditData.push(statusChangeAudit);

  this._dataContextService.postDatawithValues<any>(this.service_URL.OutwardDetails.UpdateStatus, params)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      if (res == 1) {
        this.toast.success("Request Approved by L1 Approver");
        this.EditOutwardDetails.status = 'L1 Approved';
        
        // Saving Data in Audit Trail - only on success
        // let auditParams = {
        //   actionPerformed: "Status Change",
        //   actionPerformedOn: "Outward",
        //   changedBy: localStorage.getItem('email'),
        //   dateChanged: new Date(),
        //   primaryKey: selectedRequest.serialNumber,
        //   generalInformation: [],
        //   material: [],
        //   statusChange: auditData
        // };

        // console.log('Calling audit trail API:', this.service_URL.AuditTrail.savetransactionaudittrail);
        // console.log('Audit trail params:', auditParams);

        // this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail, auditParams)
        //   .pipe(takeUntil(this.unsubscribe$))
        //   .subscribe(
        //     (auditRes) => {
        //       console.log('Audit trail saved successfully:', auditRes);
        //     },
        //     (auditErr) => {
        //       console.error('Error saving audit trail:', auditErr);
        //       this.toast.warning('Approval saved but audit trail failed');
        //     },
        //     () => {
        //       // Delay reload to ensure audit trail completes
        //       setTimeout(() => {
        //         window.location.reload();
        //       }, 500);
        //     }
        //   );
        
        // Reload page directly without audit trail
        window.location.reload();
      } else {
        this.toast.error("Something went wrong");
      }
    },
    (err) => {
      console.error('Error updating status:', err);
      this.toast.error("Something went wrong");
    });
}

isL1Approver(): boolean {
  return this.Roles.includes('L1Approver') && this.emailId === this.OutwardDetails.approverEmailL1;
}

back(){
  this.rounter.navigate(['/OutwardL1Approver']); 
}
viewFile(index: number) {
  if (this.attachedFiles.length > 0 && index < this.attachedFiles.length) {
    const file = this.attachedFiles[index];
    const fileName: string = file.name;
    const fileId = file.fileId;
    const extension = fileName.split('.').pop()?.toLowerCase();

    console.log(`Viewing file: ${fileName}, reqId: ${this.requestId}, fileId: ${fileId}`);
    this._dataContextService.get<any>(`${this.service_URL.OutwardDetails.Download}?reqId=${this.id}&fileId=${fileId}`)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        console.log("download file result: " + res);
        const base64 = res.file.fileBase64;
        if (extension === 'pdf') {
          const dataUrl = `data:application/pdf;base64,${base64}`;
          const pdfWindow = window.open("");
          if (pdfWindow) {
            pdfWindow.document.write(`<iframe width='100%' height='100%' src='${dataUrl}'></iframe>`);
          }
          return;
        }
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        let blob: Blob;
        let mimeType: string;
        
        switch (extension) {
          case 'pdf':
            mimeType = 'application/pdf';
            break;
          case 'doc':
          case 'docx':
            mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            break;
          case 'xls':
          case 'xlsx':
            mimeType = 'application/vnd.ms-excel';
            break;
          case 'jpg':
          case 'jpeg':
            mimeType = 'image/jpeg';
            break;
          case 'png':
            mimeType = 'image/png';
            break;
          default:
            mimeType = 'application/octet-stream';
        }

        blob = new Blob([byteArray], { type: mimeType });
        const blobURL = URL.createObjectURL(blob);
        const fileWindow = window.open("");
        if (fileWindow) {
          if (mimeType.startsWith('image/')) {
            fileWindow.document.write(`<img src='${blobURL}' width='100%' height='100%' />`);
          } else if (mimeType === 'application/pdf') {
            fileWindow.document.write(`<iframe width='100%' height='100%' src='${blobURL}'></iframe>`);
          } else if (mimeType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            mammoth.convertToHtml({ arrayBuffer: byteArray.buffer })
              .then((result) => {
                fileWindow.document.write(result.value);
              })
              .catch((error) => {
                console.log(error);
                this.toast.error("File could not be rendered");
              });
          } else if (mimeType === 'application/vnd.ms-excel') {
            const workbook = XLSX.read(byteArray, { type: 'array' });
            const html = XLSX.utils.sheet_to_html(workbook.Sheets[workbook.SheetNames[0]]);
            fileWindow.document.write(html);
          } else {
            fileWindow.document.write(`<iframe width='100%' height='100%' src='${blobURL}'></iframe>`);
          }
        }
      },
      (error) => {
        console.log(error);
        this.toast.error("File could not be downloaded");
      });
  } else {
    console.log("Invalid file index or no attached files.");
  }
}

private syncViewportState(): void {
  if (typeof window === 'undefined') {
    this.isMobileView = false;
    return;
  }

  this.isMobileView = window.innerWidth <= this.mobileBreakpoint;
}
}
